(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["layered-slideshow"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', () => {
  const slideshows = document.querySelectorAll('layered-slideshow-component');

  slideshows.forEach((slideshow) => {
    const tabs = slideshow.querySelectorAll('[role="tab"]');
    if (tabs.length <= 1) return;

    let currentIndex = 0;
    let autoplayInterval;
    let inactivityTimeout;

    const activateTab = (index) => {
      tabs[index].click();
      currentIndex = index;
    };

    const stopAutoplay = () => {
      clearInterval(autoplayInterval);
    };

    const startAutoplay = () => {
      stopAutoplay(); // evita múltiplos intervalos
      autoplayInterval = setInterval(() => {
        const nextIndex = (currentIndex + 1) % tabs.length;
        activateTab(nextIndex);
      }, 5000); // gira a cada 5 segundos
    };

    const resetInactivityTimer = () => {
      clearTimeout(inactivityTimeout);

      // para autoplay enquanto usuário interage
      stopAutoplay();

      // após 8s sem interação, volta autoplay
      inactivityTimeout = setTimeout(() => {
        startAutoplay();
      }, 8000);
    };

    // Inicia autoplay automaticamente
    startAutoplay();

    // Pausa temporária ao interagir com mouse ou foco
    slideshow.addEventListener('mouseenter', stopAutoplay);
    slideshow.addEventListener('mouseleave', resetInactivityTimer);
    slideshow.addEventListener('focusin', stopAutoplay);
    slideshow.addEventListener('focusout', resetInactivityTimer);

    // Clique manual pausa e reinicia só após 8s
    tabs.forEach((tab, index) => {
      tab.addEventListener('click', () => {
        currentIndex = index;
        resetInactivityTimer();
      });
    });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pagina-inicial"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('responsive-banner-stack')) {
    customElements.define('responsive-banner-stack', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController();
        // Section HTML may be inserted by the Shopify editor after registration.
        this.frame = requestAnimationFrame(() => this.init());
      }
      init() {
        this.frame = null;
        if (!this.isConnected) return;
        const options = { signal: this.controller.signal };
        this.slides = Array.from(this.querySelectorAll('[data-banner-slide]'));
        this.slideMap = new Map(this.slides.map(slide => [slide.dataset.slideIndex, slide]));
        this.buttons = new Map(Array.from(this.querySelectorAll('[data-target-id]'), button => [button.dataset.targetId, button]));
        this.titles = new Map(Array.from(this.querySelectorAll('[data-title-id]'), title => [title.dataset.titleId, title]));
        this.motion = matchMedia('(prefers-reduced-motion: reduce)');
        this.active = null;
        this.updateActive(this.slides[0]?.dataset.slideIndex);
        this.addEventListener('click', event => {
          if (!(event.target instanceof Element)) return;
          const button = event.target.closest('[data-target-id]');
          if (!button || !this.contains(button)) return;
          const slide = this.slideMap.get(button.dataset.targetId);
          if (!slide) return;
          this.scrollTo({ top: slide.offsetTop, behavior: this.motion.matches ? 'auto' : 'smooth' });
        }, options);
        if ('IntersectionObserver' in window && this.slides.length > 1) {
          this.observer = new IntersectionObserver(entries => {
            const visible = entries.filter(entry => entry.isIntersecting && entry.intersectionRatio >= .5)
              .sort((a, b) => b.intersectionRatio - a.intersectionRatio)[0];
            if (visible) this.updateActive(visible.target.dataset.slideIndex);
          }, { root: this, threshold: [.5, .6] });
          this.slides.forEach(slide => this.observer.observe(slide));
        } else if (this.slides.length > 1) {
          this.addEventListener('scroll', () => {
            if (this.scrollFrame) return;
            this.scrollFrame = requestAnimationFrame(() => {
              this.scrollFrame = null;
              const index = Math.min(this.slides.length - 1, Math.max(0, Math.round(this.scrollTop / Math.max(1, this.clientHeight))));
              this.updateActive(this.slides[index]?.dataset.slideIndex);
            });
          }, { ...options, passive: true });
        }
      }
      updateActive(id) {
        if (!id || id === this.active) return;
        for (const [key, selected] of [[this.active, false], [id, true]]) {
          const button = this.buttons.get(key);
          button?.classList.toggle('is-active', selected);
          button?.setAttribute('aria-current', String(selected));
          this.titles.get(key)?.classList.toggle('is-active', selected);
        }
        this.active = id;
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.controller = null;
        this.observer?.disconnect();
        cancelAnimationFrame(this.frame);
        cancelAnimationFrame(this.scrollFrame);
        this.frame = this.scrollFrame = null;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["whatsapp-product-page"] && !Shopify.designMode) return;
  try {
    

if (!customElements.get('boutique-whatsapp')) {

  customElements.define(
    'boutique-whatsapp',

    class extends HTMLElement {

      connectedCallback() {

        if (this.controller) return;


        /* =====================================================
           BASE
        ===================================================== */

        this.controller = new AbortController();

        const options = {
          signal: this.controller.signal
        };

        const dialog =
          this.querySelector('dialog');

        const launcher =
          this.querySelector('.bwa-launcher');

        const form =
          this.querySelector('form');

        const message =
          this.querySelector('textarea');

        const error =
          this.querySelector('.bwa-error');

        const body =
          this.querySelector('.bwa-body');


        this.dialog = dialog;
        this.launcher = launcher;


        /* =====================================================
           WHATSAPP
        ===================================================== */

        const phone =
          (this.dataset.phone || '')
            .replace(/\D/g, '');

        const validPhone =
          /^[1-9]\d{7,14}$/.test(phone);

        const editor =
          Boolean(
            window.Shopify &&
            window.Shopify.designMode
          );

        launcher.hidden =
          !validPhone && !editor;


        /* =====================================================
           STICKY ADD TO CART
           Mesmo comportamento usado pelo Story
        ===================================================== */

        const stickyBar =
          document.querySelector('[data-stuck]');

        let stickyObserver = null;


        const adjustStickyOffset = () => {

          /*
           * Desktop:
           * volta sempre para o offset normal.
           */
          if (window.innerWidth >= 750) {

            this.style.setProperty(
              '--bwa-active-bottom',
              'var(--bwa-bottom)'
            );

            return;
          }


          /*
           * Mobile sem sticky encontrado:
           * mantém posição configurada normalmente.
           */
          if (!stickyBar) {

            this.style.setProperty(
              '--bwa-active-bottom',
              'var(--bwa-bottom)'
            );

            return;
          }


          const isStuck =
            stickyBar.getAttribute('data-stuck') === 'true';


          /*
           * Sticky ativo:
           *
           * altura real do Sticky ATC
           * +
           * 16px de respiro
           */
          if (isStuck) {

            const stickyHeight =
              stickyBar.offsetHeight || 60;

            const offset =
              stickyHeight + 16;

            this.style.setProperty(
              '--bwa-active-bottom',
              offset + 'px'
            );

          }

          /*
           * Sticky desativado:
           * volta para o offset original
           * configurado no editor.
           */
          else {

            this.style.setProperty(
              '--bwa-active-bottom',
              'var(--bwa-bottom)'
            );

          }

        };


        /*
         * MutationObserver:
         * observa exatamente a mudança:
         *
         * data-stuck="false"
         *          ↓
         * data-stuck="true"
         *
         * Sem scroll listener.
         * Sem polling.
         */

        if (stickyBar) {

          stickyObserver =
            new MutationObserver(
              adjustStickyOffset
            );

          stickyObserver.observe(
            stickyBar,
            {
              attributes: true,
              attributeFilter: ['data-stuck']
            }
          );

        }


        /*
         * Recalcula também quando muda
         * orientação/tamanho da viewport.
         */

        window.addEventListener(
          'resize',
          adjustStickyOffset,
          {
            passive: true,
            signal: this.controller.signal
          }
        );


        /*
         * Estado inicial.
         */

        adjustStickyOffset();


        /*
         * Guarda observer para destruir
         * caso Shopify remova/recarregue section.
         */

        this.stickyObserver =
          stickyObserver;


        /* =====================================================
           MOTION
        ===================================================== */

        const reducedMotion =
          window.matchMedia(
            '(prefers-reduced-motion: reduce)'
          );

        let closing = false;
        let opener = null;


        const animate = (
          frames,
          duration
        ) => {

          this.animation?.cancel();

          this.animation = null;


          if (
            reducedMotion.matches ||
            !dialog.animate
          ) {
            return null;
          }


          this.animation =
            dialog.animate(
              frames,
              {
                duration,
                easing:
                  'cubic-bezier(.22, 1, .36, 1)',
                fill: 'both'
              }
            );


          return this.animation;

        };


        reducedMotion.addEventListener(
          'change',

          () => {

            if (reducedMotion.matches) {
              this.animation?.finish();
            }

          },

          options
        );


        /* =====================================================
           CLOSE
        ===================================================== */

        const close = async () => {

          if (
            !dialog.open ||
            closing
          ) {
            return;
          }


          closing = true;

          dialog.classList.add(
            'is-closing'
          );


          const current =
            this.animation
              ? getComputedStyle(dialog)
              : null;


          const from =
            current
              ? {
                  opacity:
                    current.opacity,

                  transform:
                    current.transform
                }

              : {
                  opacity: 1,
                  transform:
                    'translateY(0)'
                };


          const animation =
            animate(
              [
                from,

                {
                  opacity: 0,
                  transform:
                    'translateY(10px)'
                }
              ],

              200
            );


          if (animation) {

            try {

              await animation.finished;

            }

            catch (_) {

              return;

            }

          }


          if (
            this.controller?.signal.aborted ||
            !this.isConnected
          ) {
            return;
          }


          dialog.close();


          this.animation?.cancel();

          this.animation = null;


          dialog.classList.remove(
            'is-closing'
          );


          closing = false;

        };


        /* =====================================================
           OPEN
        ===================================================== */

        const open = () => {

          if (
            dialog.open ||
            closing
          ) {
            return;
          }


          /*
           * Recalcula antes de abrir.
           * Assim o modal já nasce acima
           * do Sticky ATC.
           */

          adjustStickyOffset();


          opener =
            document.activeElement;


          dialog.showModal();

          body.scrollTop = 0;


          const animation =
            animate(
              [
                {
                  opacity: 0,
                  transform:
                    'translateY(16px)'
                },

                {
                  opacity: 1,
                  transform:
                    'translateY(0)'
                }
              ],

              360
            );


          if (animation) {

            animation.finished

              .then(() => {

                if (
                  this.animation !==
                  animation
                ) {
                  return;
                }


                animation.cancel();

                this.animation = null;

              })

              .catch(() => {});

          }


          launcher.setAttribute(
            'aria-expanded',
            'true'
          );


          if (!validPhone) {

            error.textContent =
              'Configure um número válido no editor desta section: DDI + DDD + número, sem o zero de operadora.';

            error.hidden = false;

          }

        };


        /* =====================================================
           REDIRECT
        ===================================================== */

        const redirect = (text) => {

          if (!validPhone) {

            error.textContent =
              'O atendimento pelo WhatsApp ainda não está configurado.';

            error.hidden = false;

            return;

          }


          window.location.assign(
            'https://wa.me/' +
            phone +
            '?text=' +
            encodeURIComponent(text)
          );

        };


        /* =====================================================
           CLICK HANDLER
        ===================================================== */

        this.addEventListener(

          'click',

          event => {

            if (
              !(event.target instanceof Element)
            ) {
              return;
            }


            const button =
              event.target.closest('button');


            if (
              !button ||
              !this.contains(button)
            ) {
              return;
            }


            if (button === launcher) {

              open();

            }

            else if (
              button.classList.contains(
                'bwa-close'
              )
            ) {

              close();

            }

            else if (
              button.classList.contains(
                'bwa-question'
              )
            ) {

              redirect(
                button.dataset.message
              );

            }

          },

          options
        );


        /* =====================================================
           DIALOG EVENTS
        ===================================================== */

        dialog.addEventListener(

          'cancel',

          event => {

            event.preventDefault();

            close();

          },

          options
        );


        dialog.addEventListener(

          'close',

          () => {

            launcher.setAttribute(
              'aria-expanded',
              'false'
            );


            this.animation?.cancel();

            this.animation = null;

            closing = false;


            dialog.classList.remove(
              'is-closing'
            );


            const target =
              opener instanceof HTMLElement &&
              opener.isConnected &&
              opener !== document.body

                ? opener

                : launcher;


            if (!target.hidden) {

              target.focus({
                preventScroll: true
              });

            }

          },

          options
        );


        /*
         * Clique fora do conteúdo.
         */

        dialog.addEventListener(

          'click',

          event => {

            if (
              event.target !== dialog
            ) {
              return;
            }


            const rect =
              dialog.getBoundingClientRect();


            if (
              event.clientX < rect.left ||
              event.clientX > rect.right ||
              event.clientY < rect.top ||
              event.clientY > rect.bottom
            ) {

              close();

            }

          },

          options
        );


        /* =====================================================
           FORM
        ===================================================== */

        message.addEventListener(

          'input',

          () => {

            message.setCustomValidity('');

          },

          options
        );


        form.addEventListener(

          'submit',

          event => {

            event.preventDefault();


            const text =
              message.value.trim();


            message.setCustomValidity(
              text
                ? ''
                : 'Escreva sua mensagem.'
            );


            if (
              form.reportValidity()
            ) {

              redirect(text);

            }

          },

          options
        );


        /* =====================================================
           SHOPIFY THEME EDITOR
        ===================================================== */

        if (editor) {

          this.addEventListener(
            'shopify:block:select',
            open,
            options
          );


          document.addEventListener(

            'shopify:section:select',

            event => {

              if (
                event.target.contains(this)
              ) {

                open();

              }

            },

            options
          );


          document.addEventListener(

            'shopify:section:deselect',

            event => {

              if (
                event.target.contains(this) &&
                dialog.open
              ) {

                close();

              }

            },

            options
          );

        }

      }


      /* =======================================================
         CLEANUP
      ======================================================= */

      disconnectedCallback() {

        this.controller?.abort();

        this.stickyObserver?.disconnect();

        this.stickyObserver = null;


        this.animation?.cancel();

        this.animation = null;


        this.dialog?.classList.remove(
          'is-closing'
        );


        this.launcher?.setAttribute(
          'aria-expanded',
          'false'
        );


        this.controller = null;


        const dialog =
          this.querySelector('dialog');


        if (dialog?.open) {

          dialog.close();

        }

      }

    }

  );

}


  } catch(e) { console.error(e); }
})();
})();
